"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BROADCAST_CHANNEL = exports.BROADCAST_CHANNEL = "launchDarkly";


//////////////////
// WEBPACK FOOTER
// ./~/react-launch-darkly/build/constants/LaunchDarkly.js
// module id = 584
// module chunks = 0